import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

//Nav
import OrgStrucureNav from "./OrgStrucureNav";
import OrgStrucureContent from "./OrgStrucureContent";

//DataTable
import { ViewCompanyProfile } from "../../../../Types/CompanyProfile/CompanyProfile";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const OrgStrucureCard = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const [basicTab, setBasicTab] = useState("1");

  return (
    <Card className="card-absolute">
      <CommonCardHeader
        headClass="bg-primary"
        tagClass="txt-light"
        title={"Organizational Structure"}
      />

      <CardBody>
        <OrgStrucureNav basicTab={basicTab} setBasicTab={setBasicTab} />
        <OrgStrucureContent tabId={basicTab} companyInfo={companyInfo} />
      </CardBody>
    </Card>
  );
};

export default OrgStrucureCard;
